import React, { useEffect } from 'react';
import TabForm from './TabForm';

import styled from 'styled-components';

const TabConsole = ({ className }) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className={className}>
      <TabForm />
    </div>
  );
};

export default styled(TabConsole)`
  margin-top: 7rem;
`;
